import { useSearchParams } from 'react-router-dom';

const TIRE_QUOTE_SLUG_PARAM = 'tire-quote-slug';

export const useTireQuoteSlug = (): string | undefined => {
  const [searchParams] = useSearchParams();
  return searchParams.get(TIRE_QUOTE_SLUG_PARAM) ?? undefined;
};
